/**
 * Created by Jew on 7/13/2017.
 */
import {Component, Inject, ViewChild} from '@angular/core';
import { MatLegacyDialog as MatDialog, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {IdexService} from 'app/idex.service';
import {LoadingButtonComponent} from 'app/shared/loading-button/button';
import {TranslateService} from '@ngx-translate/core';
import {FileSizePipe} from '../../shared/file-size.pipe';
import {Toast} from '../../shared/toast/toast';

@Component({
   selector: 'app-register-etax',
   templateUrl: './register-etax.component.html',
   styleUrls: ['./register-etax.component.css']
})
export class RegisterEtaxComponent {
   @ViewChild('upload') upload: any;
   @ViewChild('submit') button: LoadingButtonComponent;
   @ViewChild('close') close: any;
   title: string;
   show = false;
   error: any;
   error_email: any;
   error_file: any;
   user: any;
   hide_form = true;
   server: any = '';
   port: any = '993';
   list_filename: File[] = [];
   maxFileSize = 5242880;
   taxId: string;
   taxName: string;
   taxEmail = '';
   taxPassword: string;
   busy: boolean;

   constructor(@Inject(MAT_DIALOG_DATA) private data: any, public dialog: MatDialog, private dialogRef: MatDialogRef<RegisterEtaxComponent>,
               private service: IdexService, private translate: TranslateService, private fileSize: FileSizePipe,
               private toast: Toast) {
   }

   submitNext() {
      this.translate.get('registerEtax.title').subscribe(s => this.title = s);
      this.hide_form = false;
   }

   submit_etax() {
      if (this.list_filename.length > 0) {
         this.upload.disabled = true;
         this.close.disabled = true;
         this.service.upgradeEtax(this.data.tin, this.data.name, this.taxEmail.toLowerCase(),
            this.taxPassword, this.server, this.port, this.list_filename)
            .subscribe
            (() => {
               this.translate.get('registerEtax.success').subscribe(s => this.toast.info(s));
               this.data.service.getCompanyInfo(this.data.name);
               this.dialogRef.close(true);
            }, err => {
               this.button.reset();
               this.upload.disabled = false;
               this.close.disabled = false;
            });
      } else {
         this.translate.get('alert.error_upload_cert').subscribe(s => this.toast.error(s.toString()));
         this.upload.disabled = false;
         this.close.disabled = false;
         this.button.reset();
      }
   }

   onChange(input: any) {
      let error = '';
      for (let i = 0; i < input.files.length; i++) {
         const file = input.files[i];
         if (file.size > this.maxFileSize) {
            if (error) {
               error += '<br/>';
            }
            this.translate.get('alert.cert_upload_exceed', {name: file.name, size: this.fileSize.transform(file.size)})
               .subscribe(s => this.toast.error(s.toString()));
            continue;
         }
         switch (file.type) {
            case 'image/jpeg':
            case 'image/jpg':
            case 'image/png':
            case 'application/pdf':
               break;
            default:
               if (error) {
                  error += '<br/>';
               }
               // error += file.name + ' ประเภทไฟล์ไม่ถูกต้อง';
               this.translate.get('alert.cert_upload_error', {name: file.name}).subscribe(s => this.toast.error(s.toString()));
               continue;
         }
         this.list_filename.push(file);
      }
      input.value = '';
      if (error) {
         this.toast.error(error);
      }
   }

   onblur(item: any) {
      const i = item.indexOf('@');
      const domain = i === -1 ? '' : item.substr(i + 1);
      this.show = domain.length > 0 && domain !== 'gmail.com' && domain !== 'outlook.com'
         && domain !== 'hotmail.com' && domain !== 'icloud.com' && domain !== 'yahoo.com';
   }

   removeFile(file: File): void {
      const i = this.list_filename.indexOf(file);
      if (i !== -1) {
         this.list_filename.splice(i, 1);
      }
   }

}

